import { memo } from "react"

const LocationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <rect width="24" height="24" fill="#F4F6F8" rx="12"></rect>
      <path
        stroke="#637381"
        d="M17.333 10.666c0 2.946-5.333 8-5.333 8s-5.333-5.054-5.333-8a5.333 5.333 0 0 1 10.666 0Z"
      ></path>
      <path
        stroke="#637381"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 11.333A.667.667 0 1 0 12 10a.667.667 0 0 0 0 1.333"
      ></path>
    </svg>
  )
}

export default memo(LocationIcon);
